// extracted by mini-css-extract-plugin
export default {"Item":"v4DATbEA","Text":"ojxEyxot","SubMenu":"NBLoVtI5","isOpen":"J5E60AB5"};